import PropTypes from "prop-types";
import React from "react";
import {header as styles} from "./styles";
import {withRouter} from "react-router-dom";

import {Fab, Typography, withStyles} from "@material-ui/core";

import {Close as CloseIcon} from "@material-ui/icons";
import {version} from "../../../config";
import logo from "../../../assets/images/logo.png";
import classNames from "classnames";

class Header extends React.Component {

	render() {
		const {classes, history} = this.props;
		return (
			<div className={classNames(classes.toolbar, classes.mediaToolbar)}>
				{version.office && (
					<div className={classNames(classes.logo)}>
						{/* <img className={classNames(classes.img)} src={logo} alt="logo"/> */}
					</div>
				)}
				<div className={classes.backActions}>
					<Typography>{"RETOUR"}</Typography>
					<Fab className={classes.btnBack} onClick={()=>{
						// history.push("/"+sessionStorage.getItem('hash'))
						history.push("/")
					}}>
						<CloseIcon/>
					</Fab>
				</div>
				{/* {version.office && <div className={classes.underHeaderLine}/>} */}
			</div>
		);
	}

}

Header.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Header));
